export const codeTypes = `
<template>
  <div>
    <b-embed type="iframe" aspect="16by9" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowfullscreen/>
  </div>
</template>

<script>
import { BEmbed } from 'bootstrap-vue'

export default {
  components: {
    BEmbed,
  },
}
</script>
`;
export const codeDefault = '';
